<template>
  <div class="filter-list_wrapper">
    <custom-dropdown
      v-model="form.status"
      :options="statusOptions"
      width="156px"
      height="35px"
      arrow-height="5"
      :multiple="true"
      arrow-width="8"
      label="Статус заказа"
      ref="statusDropdown"
      @update:modelValue="handleStatusChange"
      @open="handleDropdownOpen('status')"
    />
    <custom-dropdown
      v-model="form.online"
      :options="manufacturerOptions"
      width="156px"
      height="35px"
      :multiple="false"
      arrow-height="5"
      arrow-width="8"
      label="Тип связи"
      ref="manufacturerDropdown"
      @update:modelValue="handleManufacturerChange"
      @open="handleDropdownOpen('manufacturer')"
    />
    <custom-dropdown
      v-model="form.problems"
      :options="ordersOptions"
      width="156px"
      height="35px"
      arrow-height="5"
      :multiple="false"
      arrow-width="8"
      label="Тип заказа"
      ref="ordersDropdown"
      @update:modelValue="handleOrdersChange"
      @open="handleDropdownOpen('orders')"
    />
    <div
      v-for="button in filterButtons"
      :key="button.id"
      class="filter-list_wrapper_btn"
      @click="showModal(button)"
    >
      <span class="button-text">{{ button.text }}</span>
      <span
        v-if="button.selectedValue"
        class="clear-button"
        @click.stop="clearButtonValue(button.id)"
      >
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </span>
    </div>
  </div>
</template>

<script setup>
import CustomDropdown from "@/components/CustomDropdown.vue";
import {
  computed,
  ref,
  reactive,
  defineEmits,
  defineProps,
  defineExpose,
  watch,
  onMounted,
} from "vue";
import { useOrdersStore } from "@/store/orders";
// import { debounce } from "lodash-es";
const emit = defineEmits(["showModal", "clearFilter"]);
defineProps({
  selectOption: {
    type: [Object, String],
    default: null,
  },
});
const ordersStore = useOrdersStore();
// const { t } = useLocalization();

const form = ref({
  status: ['all'],
  online: 'all',
  problems: 'all',
});

const statusDropdown = ref(null);
const manufacturerDropdown = ref(null);
const ordersDropdown = ref(null);

const applyFilters = () => {
  ordersStore.applyFilters(); // внутри стора есть debounce
};

const handleDropdownOpen = (openedDropdown) => {
  const dropdownRefs = {
    status: statusDropdown,
    manufacturer: manufacturerDropdown,
    orders: ordersDropdown,
  };

  // Close all other dropdowns
  Object.entries(dropdownRefs).forEach(([name, ref]) => {
    if (
      name !== openedDropdown &&
      ref.value &&
      typeof ref.value.closeDropdown === "function"
    ) {
      ref.value.closeDropdown();
    }
  });
};

const buttonStates = reactive({
  1: { text: "", selectedValue: "" },
  2: { text: "", selectedValue: "" },
});

const clearButtonValue = (buttonId) => {
  switch (buttonId) {
    case 1: // Клиенты
      ordersStore.setClientsFilter([]);
      break;
    case 2: // Склады
      ordersStore.setWarehousesFilter([]);
      break;
  }
  emit("clear-filter", buttonId);
};
const filterButtons = computed(() => [
  {
    id: 1,
    text: buttonStates[1].text || "Клиенты",
    originalText: "Клиенты",
    selectedValue: buttonStates[1].selectedValue,
  },
  {
    id: 2,
    text: buttonStates[2].text || "Завод",
    originalText: "Завод",
    selectedValue: buttonStates[2].selectedValue,
  },
]);

const statusOptions = computed(() => {
  return ordersStore.availableStatuses.map((status) => ({
    value: status,
    label: ordersStore.getStatusText(status),
  }));
});

const manufacturerOptions = computed(() => [
  { label: "Все а/м", value: "all" },
  { label: "На связи", value: "1" },
  { label: "Без связи", value: "0" },
]);

const ordersOptions = computed(() => [
  { label: "Все заказы", value: "all" },
  { label: "С проблемами", value: "1" },
]);

const showModal = (button) => {
  emit("showModal", {
    title: button.originalText,
    buttonId: button.id,
    currentValue: button.selectedValue,
  });
};

// const handleStatusChange = (value) => {
//   // Если массив пустой или содержит только пустые значения, передаем null или пустой массив
//   if (
//     !value ||
//     value.length === 0 ||
//     (Array.isArray(value) && value.every((v) => !v || v === ""))
//   ) {
//     ordersStore.setStatusesFilter([]);
//   } else {
//     // Фильтруем пустые значения
//     const filteredValues = Array.isArray(value)
//       ? value.filter((v) => v && v !== "" && v !== "all")
//       : [value];
//     ordersStore.setStatusesFilter(filteredValues);
//     if (value[0] === 'all') {
//       handleDropdownOpen('');
//     }
//   }
// };

const handleStatusChange = (value) => {
  // если выбрано "all" или пусто — в стор шлём пустой массив (значит "все")
  if (!value?.length || value.includes('all')) {
    ordersStore.setStatusesFilter([]); // "все"
  } else {
    ordersStore.setStatusesFilter(value);
  }
};

const handleManufacturerChange = (value) => {
  ordersStore.setOnlineFilter(value === 'all' ? null : value);
};

const handleOrdersChange = (value) => {
  ordersStore.setProblemsFilter(value === 'all' ? null : value);
};

const syncFormWithStore = () => {
  form.value.status = (ordersStore.filters.statuses?.length
      ? ordersStore.filters.statuses
      : ['all']);

  form.value.online   = (ordersStore.filters.online   == null ? 'all' : String(ordersStore.filters.online));
  form.value.problems = (ordersStore.filters.problems == null ? 'all' : String(ordersStore.filters.problems));
};

watch(
  () => ordersStore.filters,
  (newFilters, oldFilters) => {
    // Синхронизируем форму
    form.value.status   = (newFilters.statuses?.length ? newFilters.statuses : ['all']);
    form.value.online   = (newFilters.online   == null ? 'all' : String(newFilters.online));
    form.value.problems = (newFilters.problems == null ? 'all' : String(newFilters.problems));

    // Применяем фильтры только если действительно что-то изменилось
    if (JSON.stringify(newFilters) !== JSON.stringify(oldFilters)) {
      applyFilters();
    }
  },
  { deep: true }
);

const updateButtonText = (buttonId, newText) => {
  if (newText) {
    buttonStates[buttonId].text = newText;
    buttonStates[buttonId].selectedValue = newText;
  } else {
    buttonStates[buttonId].text = "";
    buttonStates[buttonId].selectedValue = "";
  }
  switch (buttonId) {
    case 1: // Покупатели
      // ordersStore.setSelectedCustomer(newText);
      break;
    case 2: // Грузополучатель
      // ordersStore.setSelectedDriver(newText);
      break;
  }
};
onMounted(() => {
  syncFormWithStore();
});
defineExpose({
  updateButtonText,
});
</script>

<style scoped lang="scss">
.filter-list_wrapper {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(156px, 1fr));
  gap: 10px;
  margin-bottom: 16px;
  max-width: 315px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
  }

  &_btn {
    border-radius: 6px;
    border: 1px solid #dde5ed;
    padding: 8px 12px;
    cursor: pointer;
    height: 35px;
    width: 156px;
    background-color: #fff;
    color: #4d5460;
    font-size: 14px;
    font-weight: 400;
    text-align: left;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.button-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  overflow: hidden;
}

.button-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  max-width: calc(100% - 20px);
}

.clear-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  color: #4d5460;
  cursor: pointer;
  flex-shrink: 0;
}

:deep(.custom-dropdown) {
  width: 156px !important;
}

:deep(.custom-dropdown .selected-option) {
  border: 1px solid #dde5ed;
  border-radius: 6px;
  padding: 8px 12px;
  font-size: 14px;
  color: #4d5460;
  background-color: #fff;
}

:deep(.custom-dropdown .dropdown-arrow) {
  right: 12px;
}
</style>
